import { Topic } from "@/types";
import { useSuspensePaginatedQuery, UseSuspensePaginatedQueryOptions } from "@/utils/query";

export const useTopics = (
  projectId: string,
  options?: Omit<UseSuspensePaginatedQueryOptions<Topic>, "queryKey" | "url">,
) => {
  return useSuspensePaginatedQuery<Topic>({
    queryKey: ["projects", projectId, "topics"],
    url: `/projects/${projectId}/topics`,
    ...options
  });
};
